import styled from 'styled-components'

const TrendsRoot = styled.div`
  background-color: white;
`

export default TrendsRoot
